//library
import React from "react";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import { CheckCircleOutline, HourglassEmpty } from "@mui/icons-material";

import moment from "moment-timezone";

//code
import useStyles from "../styles/styles";

/**
 * Get the timezone
 * @param {object} timestamp - the time stamp of the date
 * @param {object} dateFormat - the desired date format
 * @returns The formatted timestamp
 */

const getTimezone = (timestamp, dateFormat) => {
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	return dateFormat === "DD-MMM-YYYY"
		? moment(timestamp).format(dateFormat || "DD-MMM-YYYY")
		: moment(timestamp)
				.utc(true)
				.tz(timezone)
				.format(dateFormat || "DD-MMM-YYYY hh:mm a");
};

/**
 * The row to display application information
 * @param {object} row - The row object to be displayed
 * @param {function} openManualOverride - handler to open the manual override dialog box
 * @returns the application row for the status viewer table
 */
const ApplicationTable = ({
	applications,
	openManualOverrideBox,
	openReferralDialogBox,
}) => {
	const classes = useStyles();
	return (
		<TableBody>
			{applications.map((row) => (
				<TableRow key={row.id} className={classes.row}>
					<TableCell
						component="th"
						scope="row"
						key={`index ${row.application_id}`}
					>
						<b>{row.application_id}</b>
					</TableCell>
					<TableCell>
						{getTimezone(moment(row.dateAndTime, "MMM Do YYYY, hh:mm a"))}
					</TableCell>
					<TableCell>
						<b>{row.companyName}</b>
					</TableCell>
					<TableCell align="center">
						<b
							className={
								row.enquiry_status === "accepted"
									? classes.success
									: row.enquiry_status === "declined"
									? classes.declined
									: classes.pending
							}
						>
							{row.enquiry_status}
						</b>
					</TableCell>
					<TableCell align="center">
						{row.nda_signed ? (
							<CheckCircleOutline className={classes.success} />
						) : (
							<HourglassEmpty className={classes.pending} />
						)}
					</TableCell>
					<TableCell align="center">
						{row.application_form ? (
							<CheckCircleOutline className={classes.success} />
						) : (
							<HourglassEmpty className={classes.pending} />
						)}
					</TableCell>
					<TableCell align="center">
						{row.documents_upload ? (
							<CheckCircleOutline className={classes.success} />
						) : (
							<HourglassEmpty className={classes.pending} />
						)}
					</TableCell>
					<TableCell
						align="center"
						onClick={() => openManualOverrideBox(row.application_id)}
					>
						<b
							className={
								row.current_status === "completed"
									? classes.success
									: row.current_status === "declined"
									? classes.declined
									: classes.pending
							}
						>
							{row.current_status}
						</b>
					</TableCell>
					<TableCell onClick={() => openReferralDialogBox(row)}>
						<b>{row.referredBy ? row.referredBy.referredBy : ""}</b>
					</TableCell>
					<TableCell>{row.remarks || "-"}</TableCell>
				</TableRow>
			))}
		</TableBody>
	);
};

export default ApplicationTable;
